module.exports = __webpack_public_path__ + "img/filter_icon_active.4d6d1101.svg";